import { Model } from 'pinia-orm'

import { Attr, BelongsTo, HasMany, Num, Uid } from 'pinia-orm/dist/decorators'
import { Transaction } from 'modules/Transaction/Transaction'
import { Tenant } from 'modules/Tenant/Tenant'
import { Org } from 'modules/Org/Org'

export class Project extends Model {
  static override entity = 'projects'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare name: string
  @Attr(null) declare project_number: number | null
  @Attr(null) declare job: string | null
  @Attr(null) declare client: string | null
  @Attr(null) declare cost_center: string | null
  @Attr(null) declare location: string | null
  @Attr(null) declare geolocation: string | null
  @Attr(null) declare reference: string | null
  @Attr(null) declare is_active: boolean
  @Attr(null) declare external_id: string | null

  @HasMany(() => Transaction, 'transaction_id') declare transactions: Transaction[]

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
